import { RotateCcw } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { useProgress } from "@/hooks/useProgress";
import { useToast } from "@/hooks/useToast";
import { cn } from "@/lib/utils";

export function ResetProgressButton({ className }: { className?: string }) {
  const { resetProgress, completedCount } = useProgress();
  const { toast } = useToast();

  if (completedCount === 0) return null;

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className={cn("text-muted-foreground", className)}
        >
          <RotateCcw className="mr-1.5 h-4 w-4" /> Reset progress
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Start over?</AlertDialogTitle>
          <AlertDialogDescription>
            This clears all your XP, badges, completed lessons, and certificate
            from this browser. This can't be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Keep my progress</AlertDialogCancel>
          <AlertDialogAction
            onClick={() => {
              resetProgress();
              toast({
                title: "Progress reset",
                description: "You're starting fresh. Happy learning!",
              });
            }}
          >
            Yes, reset everything
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
